/**
 * campaign-companies — Campaign by Company (Basic). DEFAULT campaign template.
 * Pipeline status graph + a deduplicated COMPANY directory (logo, name,
 * location, employee range) covering enriching → engaged leads. Deliberately
 * no lead names or roles: this report answers "which companies are moving".
 */
import { CAMPAIGN_REVISION, validateCampaignReport, translationTexts, validateTranslations, type CampaignReport, type Translations } from '../../schema/campaign';
import { renderCampaignCompaniesReport } from './render';

export const conf = {
  id: 'campaign-companies',
  name: 'Campaign by Company (Basic)',
  description: 'Pipeline status and the company directory — logo, location and size. No personal data.',
  revision: CAMPAIGN_REVISION,
  sourceKinds: ['campaign'] as const,
  pdfBucket: 'campaign-report-exports' as const,
  sectionConfig: false,
  i18n: 'dictionary' as const,
};

export const reportTemplate = {
  conf,
  validate: validateCampaignReport,
  translationTexts: (d: CampaignReport): Translations => translationTexts(d),
  validateTranslations: (d: CampaignReport, t: unknown) => validateTranslations(d, t),
  render: renderCampaignCompaniesReport,
};
